import BaseService from './index';

const baseApiPath = process.env.MIX_API_BASE_PATH;

export default {
    search(params) {
        return BaseService.get(`${baseApiPath}/articles/search`, params)
    },
}
